import React from 'react';
import { useParams } from 'next/navigation';
import { cn } from '@/utils/cn';
import TimerFlash from '../Timer/TimerFlash';
import Text3xl from '../Typography/Text3xl';

function TitleWithTimer({
  title,
  className = '',
  showCountDownTimer,
  targetStartDate,
  targetEndDate,
  isCampaignLanding = false,
}) {
  const searchParams = useParams();
  const { slug } = searchParams;

  return (
    <div
      className={cn(
        'w-full lg:w-auto justify-between lg:justify-start items-center gap-6',
        {
          'lg:w-full lg:justify-between': slug && !isCampaignLanding,
        },
        className,
      )}
    >
      <Text3xl text={title} className="font-semibold line-clamp-2" />
      {showCountDownTimer ? (
        <TimerFlash
          targetStartDate={targetStartDate}
          targetEndDate={targetEndDate}
        />
      ) : null}
    </div>
  );
}

export default TitleWithTimer;
